import { LitElement, css, html } from "lit";
import { customElement, property } from "lit/decorators.js";

@customElement("bp-global-header-menu-button")
export class GlobalHeaderMenuButton extends LitElement {
  static styles = css`
    button {
      border: 0;
      border-radius: var(--radius-md);
      background: transparent;
      appearance: none;
      display: block;
      gap: var(--size-1);
      font-family: var(--font-sans);
      font-size: var(--font-size-md);
      font-weight: var(--font-weight-semibold);
      user-select: none;
      cursor: pointer;
      color: currentColor;
      align-items: center;
      justify-content: center;
      height: var(--size-7);
      padding-inline: var(--size-1-5);
    }

    button:focus-visible {
      outline: var(--a11y-outline);
      outline-offset: calc(var(--size-0-5) * -1);

      @media (min-width: 1024px) {
        outline-offset: unset;
      }
    }

    button:focus:not(:focus-visible) {
      outline: none;
    }

    button span {
      inline-size: var(--size-2-5);
      height: 2px;
      background-color: currentColor;
      display: block;
      border-radius: var(--radius-md);
      margin: 6px auto;
      transform: translateY(0) rotate(0deg);
      transform-origin: center;
      transition: transform var(--duration-normal) var(--ease-in-out);
    }

    [aria-pressed="true"] #toggle-top {
      transform: translateY(4px) rotate(45deg);
    }

    [aria-pressed="true"] #toggle-bottom {
      transform: translateY(-4px) rotate(-45deg);
    }
  `;

  @property({
    reflect: true,
    converter: (value) => (value === "true" ? true : false),
  })
  active: boolean = false;

  focus() {
    this.shadowRoot?.querySelector("button")?.focus();
  }

  reset() {
    this.active = false;
  }

  handleClick = (e: MouseEvent) => {
    e.stopPropagation();

    this.active = !this.active;

    this.dispatchEvent(
      new CustomEvent("click", {
        bubbles: true,
        composed: true,
        detail: e.detail,
      }),
    );
  };

  render() {
    return html`
      <button
        aria-label="${this.ariaLabel}"
        aria-pressed="${this.active}"
        @click="${this.handleClick}"
      >
        <span id="toggle-top"></span>
        <span id="toggle-bottom"></span>
      </button>
    `;
  }
}
